import initDropDownsPrograms from "./dropDownPrograms";
import initDatepicker from "./init-datepicker";
import netRequests from "./netRequests";
import selects from "./selects";
import send from "./send";
import shortForm from "./shortForm";

const form = () => {
  /* Получение списка доступных программ для редиректа и передача в инициализацию поля "Программа обучения" */
  async function initNetRequests() {
    const allPrograms = await netRequests();
    // Возвращаем только онлайн программы
    const ONLINE_PROGRAMS = allPrograms.programs.filter((program) => program.educational_form == "online");
    
    initRegions(allPrograms.regions);
    initDropDownsPrograms(ONLINE_PROGRAMS);
    send();
    shortForm(ONLINE_PROGRAMS);
  }

  initDatepicker();
  selects();
  initNetRequests();

  function initRegions(data) {    
    try {
      function addRegionsSelect(id) {
        let regionsSelect = $(id);
  
        data.forEach(function (el) {
          let selected = false,
            option = new Option(el.name, el.id, false, selected);
  
          option.accessKey = el.id;
          regionsSelect.append(option);
        });
  
        regionsSelect.val(null);
        regionsSelect.select2({
          placeholder: "Ваш регион",
        });
      }
  
      addRegionsSelect("#Regions");
      addRegionsSelect("#shortFormRegions");
    } catch (e) {
      console.log(e);
    }
  }  
};

export default form;
